'use client';

import useSWR from 'swr';
import { useContext } from 'react';
import { diseasesQuery } from './diseasesQuery';
import UIDiseaseListingSection from './DiseaseListingSection.client';
import { SanityDraftClientContext } from '@/components/context';

export default async function DraftModeDiseaseListingSection() {
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR('profiles', () =>
    client?.fetch<(typeof diseasesQuery)[1]>(diseasesQuery[0])
  );

  return <UIDiseaseListingSection diseases={data ?? []} />;
}
